import { defineStore } from "pinia";
import RvApi from "@/rvapi";
import constant from "@/constant";
const { PLATFORMS } = constant;

export const useRemoteConfigStore = defineStore("remoteConfig", {
  state: () => ({
    iosConfigs: {} as Record<string, any>,
    androidConfigs: {} as Record<string, any>,
    webConfigs: {} as Record<string, any>,
  }),
  actions: {
    async getRemoteConfig(platform: string) {
      try {
        this.iosConfigs = {};
        this.androidConfigs = {};
        this.webConfigs = {};
        const data = await RvApi.getRemoteConfigs(platform);
        switch (platform) {
          case PLATFORMS.IOS:
            this.iosConfigs = data;
            break;
          case PLATFORMS.ANDROID:
            this.androidConfigs = data;
            break;
          case PLATFORMS.WEB:
            this.webConfigs = data;
            break;
        }
      } catch (error: any) {
        console.log("Error while getting config" + error);
      }
    },

    async updateRemoteConfig(platform: string, configObj: any) {
      const data = await RvApi.updateRemoteConfigs(platform, configObj);
      switch (platform) {
        case PLATFORMS.IOS:
          this.iosConfigs = data;
          break;
        case PLATFORMS.ANDROID:
          this.androidConfigs = data;
          break;
        case PLATFORMS.WEB:
          this.webConfigs = data;
          break;
      }
    },
  },
});
